import React, { Fragment, useReducer, useEffect, useState, forwardRef } from "react";
import DatePicker from "../../components/Datepicker";
import MaterialSelect from "../../components/MaterialSelect";
import api from "../../services/api";
import MaterialTable from "material-table";
import {
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import moment from "moment";
import * as XLSX from 'xlsx';
import * as CONSTANTS from "../../services/constants";
import { makeStyles } from "@material-ui/core/styles";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { TableChart, PictureAsPdf } from "@material-ui/icons";
import PictureAsPdfTwoToneIcon from '@material-ui/icons/PictureAsPdfTwoTone';

const useStyles = makeStyles(theme => ({
  formControl: {
    maxWidth: 230,
    minWidth: 150,
    marginInline: 15
  },
  pdf: {
    marginTop: "10px",
    marginLeft: "20px",
  },
  groupButtons: {
    display: "flex",
    alignItems: "flex-end",
    marginLeft: "60px"
  },
  selectEmpty: {
    // marginTop: theme.spacing(2)
  }
}));
const initialState = {
  SelectedDocName: "",
  SelectedDocStatus: "",
  SelectedDocType: "",
  SelectedDocSector: "",
  SelectedEmployeeStatusId: "",
  SelectedCompanyStatus: "",
  SelectedDocuments: "",
  year: "",
  month: "",
  cnpj: "",
  socialName: "",
  EmployeeName: "",
  onlyExpiredDocument: false,
  validityDate: "",
  toValidityDate: "",
  createdAt: null,
  updatedAt: null,
  page: 1
};

function reducer(filter, { field, value }) {
  return {
    ...filter,
    [field]: value
  };
}

const DocumentCompanyReport = () => {
  const [filter, dispatch] = useReducer(reducer, initialState);
  const [dataDocuments, setDocuments] = useState({
    load: true,
    documentSectors: [],
    companyStatuses: [],
    documentsAttached: [],
    documentStatuses: [],
    employeeStatuses: [],
    documentsList:[],

    columns: [
      { title: "Empresa", field: "CompanyName"},
      { title: "CNPJ", field: "cnpj" },
      { title: "Status Empresa.", field: "CompanyStatus" },
      { title: "Colaborador", field: "EmployeeName" },
      { title: "Status Colab.", field: "EmployeeStatus" },
      { title: "Documento", field: "DocumentName" },
      { title: "Status Doc.", field: "AttachmentStatus" },
      { title: "Validade", field: "validityDate" },
      { title: "Ref. Mês", field: "month" },
      { title: "Ref. Ano", field: "year" },
      { title: "Data de Envio", field: "createdAt" },
      { title: "Última modificação", field: "updatedAt" },
      { title: "Aprovado por", field: "UserApprover" }
    ],
    updated: null,
    created: null
  });
  const classes = useStyles();

  const onChange = e => {
    const { name, value } = e.target;
    console.log("TCL: DocumentCompanyReport -> name, value", name, value);
    dispatch({ field: name, value: value });
  };

  useEffect(() => {
    fetchAPI();
  }, []);

  const fetchAPI = async () => {
    setDocuments({ ...dataDocuments, load: true });
    // const types = "/document-types";
    const status = "/document-status";
    const companyStatus = "/company-status";
    const sectors = "/sectors";
    const created_at = dataDocuments.created ? dataDocuments.created : "";
    const updated_at = dataDocuments.updated ? dataDocuments.updated : "";
    const attachs = `/reports/employee/documents?page=${filter.page}&CompanyStatusId=${filter.SelectedCompanyStatus}&EmployeeName=${filter.EmployeeName}&socialName=${filter.socialName}&cnpj=${filter.cnpj}&AttachmentStatusId=${filter.SelectedDocStatus}&EmployeeStatusId=${filter.SelectedEmployeeStatusId}&description=${filter.SelectedDocName}&year=${year}&month=${month}&sector=${filter.SelectedDocSector}&createdAt=${created_at}&updatedAt=${updated_at}`;
    const employeeStatus = "/employee-status";
    const documentsList = "/documents";

    // const requestTypes = await api.get(types);
    const requestStatus = await api.get(status);
    const requestDocuments = await api.get(documentsList);
    const requestCompanyStatus = await api.get(companyStatus);
    const requestSectors = await api.get(sectors);
    const requestAttachs = await api.get(attachs);
    const requestEmployeeStatus = await api.get(employeeStatus);

    const formatedAttachs = await formatData(requestAttachs);

    setDocuments({
      ...dataDocuments,
      companyStatuses: requestCompanyStatus.data.rows,
      documentStatuses: [...requestStatus.data.rows, {id:99, name:"Vencido", description:"Vencido" }],
      documentSectors: requestSectors.data.rows,
      documentsAttached: formatedAttachs,
      documentsList: requestDocuments.data.rows,
      employeeStatuses: requestEmployeeStatus.data.rows,
      load: false
    });
  };

  const formatData = async documentsAttached => {
  
    return await documentsAttached.data.rows.map(item => {
      let expired = (item.validityDate) ? (moment.utc(item.validityDate) < moment()) : false

      if(expired) {
        var statusDoc = 'Vencido';
      } else {
        var statusDoc = item.AttachmentStatus.name ? item.AttachmentStatus.name : "Não definido";
      }

      return {
        DocumentName: item.Document.description
          ? item.Document.description
          : "Não definido",
        AttachmentStatus: statusDoc,
        createdAt: moment.utc(item.createdAt).format("DD/MM/YYYY"),
        updatedAt: moment.utc(item.updatedAt).format("DD/MM/YYYY"),
        validityDate: item.validityDate
          ? moment.utc(item.validityDate).format("DD/MM/YYYY")
          : "Não definido",
        year: item.year ? item.year : "Não informado",
        month: item.month ? item.month : "Não informado",
        EmployeeName: item.Employee.name ? item.Employee.name : "Não definido",
        EmployeeStatus: item.Employee.EmployeeStatus.description,
        CompanyName: item.Employee.Company.socialName
          ? item.Employee.Company.socialName
          : "Não definido",
        cnpj: item.Employee.Company.cnpj
          ? item.Employee.Company.cnpj
          : "Não definido",
        CompanyStatus: item.Employee.Company.CompanyStatus.description,
        UserApprover: item.User ? item.User.name : "Não aprovado"
      };
    });
  };

  const setCreatedAt = e => {
    setDocuments({ ...dataDocuments, created: e });
  };

  const setUpdatedAt = e => {
    console.log("TCL: setDate -> e", e);
    setDocuments({ ...dataDocuments, updated: e });
  };

  const searchAttachs = async () => {
    setDocuments({ ...dataDocuments, load: true });
    const {
      SelectedDocName,
      SelectedDocStatus,
      EmployeeName,
      SelectedDocSector,
      SelectedEmployeeStatusId,
      SelectedCompanyStatus,
      SelectedDocuments,
      year,
      month,
      socialName,
      cnpj,
      page,
      updatedAt,
      createdAt
    } = filter;

    const created_at = dataDocuments.created ? dataDocuments.created : "";
    const updated_at = dataDocuments.updated ? dataDocuments.updated : "";
    const attachs = `/reports/employee/documents?page=${page}&CompanyStatusId=${SelectedCompanyStatus}&DocumentId=${SelectedDocuments}&EmployeeName=${EmployeeName}&socialName=${socialName}&cnpj=${cnpj}&AttachmentStatusId=${SelectedDocStatus}&EmployeeStatusId=${SelectedEmployeeStatusId}&description=${SelectedDocName}&year=${year}&month=${month}&sector=${SelectedDocSector}&createdAt=${created_at}&updatedAt=${updated_at}`;
    const response = await api.get(attachs);

    const formatedAttachs = await formatData(response);

    setDocuments({
      ...dataDocuments,
      documentsAttached: formatedAttachs,
      load: false
    });
  };

  const customPdfButton = () => {
    const title = "DPWCDI Report - Documentos Colaboradores";
    const fileName = `DPWCDI Report Documentos Colaboradores - ${moment().format(
      "DD/MM/YYYY"
    )}`;

    // Build date range subtitle if dates are provided
    let dateRangeText = "";
    if (dataDocuments.created || dataDocuments.updated) {
      const startDate = dataDocuments.created ? moment(dataDocuments.created).format("DD/MM/YYYY") : "...";
      const endDate = dataDocuments.updated ? moment(dataDocuments.updated).format("DD/MM/YYYY") : "...";
      dateRangeText = `Período: ${startDate} - ${endDate}`;
    }

    const headers = [
      [
        "Empresa",
        "CNPJ",
        "Status Empresa",
        "Colaborador",
        "Status Colab.",
        "Documento",
        "Status Doc.",
        "Validade",
        "Ref. Mês",
        "Ref. Ano",
        "Data de Envio",
        "Última modificação",
        "Aprovador"
      ]
    ];

    const data = dataDocuments.documentsAttached.map(item => [
      item.CompanyName,
      item.cnpj,
      item.CompanyStatus,
      item.EmployeeName,
      item.EmployeeStatus,
      item.DocumentName,
      item.AttachmentStatus,
      item.validityDate,
      item.month,
      item.year,
      item.createdAt,
      item.updatedAt,
      item.UserApprover
    ]);

    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "landscape"; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(15);
    let currentY = 20;

    // Add title
    doc.text(title, marginLeft, currentY);
    currentY += 20;

    // Add date range if provided
    if (dateRangeText) {
      doc.setFontSize(12);
      doc.text(dateRangeText, marginLeft, currentY);
      currentY += 15;
    }

    let content = {
      startY: currentY + 10,
      head: headers,
      body: data
    };

    doc.autoTable(content);
    doc.save(fileName);
  };

  const exportToExcel = () => {
    // Create workbook
    const wb = XLSX.utils.book_new();
    
    // Prepare headers and data
    const headers = ['Empresa', 'CNPJ', 'Status Empresa', 'Colaborador', 'Status Colab.', 'Documento', 'Status Doc.', 'Validade', 'Ref. Mês', 'Ref. Ano', 'Data de Envio', 'Última modificação', 'Aprovador'];
    const data = dataDocuments.documentsAttached.map(item => [
      item.CompanyName,
      item.cnpj,
      item.CompanyStatus,
      item.EmployeeName,
      item.EmployeeStatus,
      item.DocumentName,
      item.AttachmentStatus,
      item.validityDate,
      item.month,
      item.year,
      item.createdAt,
      item.updatedAt,
      item.UserApprover
    ]);

    // Build date range text if dates are provided
    let dateRangeText = "";
    if (dataDocuments.created || dataDocuments.updated) {
      const startDate = dataDocuments.created ? moment(dataDocuments.created).format("DD/MM/YYYY") : "...";
      const endDate = dataDocuments.updated ? moment(dataDocuments.updated).format("DD/MM/YYYY") : "...";
      dateRangeText = `Período: ${startDate} - ${endDate}`;
    }

    // Create worksheet structure with title and optional date range
    let worksheetData = [
      [], // Empty row
      ['DPWCDI Report - Documentos Colaboradores'], // Title
      [`Gerado em: ${moment().format('DD/MM/YYYY HH:mm')}`] // Generation date
    ];

    // Add date range if provided
    if (dateRangeText) {
      worksheetData.push([dateRangeText]);
    }

    // Add empty row and headers
    worksheetData.push([], headers, ...data);

    const ws = XLSX.utils.aoa_to_sheet(worksheetData);

    // Calculate merges based on whether date range is included
    const titleRowIndex = 1;
    const dateGenRowIndex = 2;
    const dateRangeRowIndex = dateRangeText ? 3 : -1;
    const headerRowIndex = dateRangeText ? 5 : 4;

    // Merge cells for title, generation date, and optional date range
    ws['!merges'] = [
      { s: { r: titleRowIndex, c: 0 }, e: { r: titleRowIndex, c: 12 } }, // Title spans columns A-M
      { s: { r: dateGenRowIndex, c: 0 }, e: { r: dateGenRowIndex, c: 12 } } // Generation date spans columns A-M
    ];

    // Add date range merge if it exists
    if (dateRangeText) {
      ws['!merges'].push({ s: { r: dateRangeRowIndex, c: 0 }, e: { r: dateRangeRowIndex, c: 12 } });
    }

    // Set column widths
    ws['!cols'] = [
      { wch: 25 },  // Empresa
      { wch: 18 },  // CNPJ
      { wch: 15 },  // Status Empresa
      { wch: 25 },  // Colaborador
      { wch: 15 },  // Status Colab.
      { wch: 30 },  // Documento
      { wch: 15 },  // Status Doc.
      { wch: 12 },  // Validade
      { wch: 10 },  // Ref. Mês
      { wch: 10 },  // Ref. Ano
      { wch: 12 },  // Data de Envio
      { wch: 12 },  // Última modificação
      { wch: 20 }   // Aprovador
    ];

    // Style header row with blue background and white text
    headers.forEach((header, index) => {
      const cellRef = XLSX.utils.encode_cell({ r: headerRowIndex, c: index });
      if (ws[cellRef]) {
        ws[cellRef].s = {
          font: { bold: true, color: { rgb: 'FFFFFF' } },
          fill: { fgColor: { rgb: '1e88e5' } },
          alignment: { horizontal: 'center', vertical: 'center' }
        };
      }
    });

    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Documentos Colaboradores');

    // Generate filename with current date
    const fileName = `DPWCDI_Report_Documentos_Colaboradores_${moment().format('DD-MM-YYYY')}.xlsx`;

    // Save file
    XLSX.writeFile(wb, fileName);
  };

  const tableIcons = {
    Export: forwardRef((props, ref) => (
      <Button
        size="small"
        className={"btn-info"}
        startIcon={<TableChart {...props} ref={ref} color="action" />}
        onClick={exportToExcel}
      >
        XLS
      </Button>
    )),
    DetailPanel: () => null,
    SortArrow: () => null
  };

  const {
    SelectedDocName,
    SelectedDocStatus,
    EmployeeName,
    SelectedDocSector,
    SelectedDocuments,
    SelectedEmployeeStatusId,
    SelectedCompanyStatus,
    socialName,
    cnpj,
    page,
    year,
    month,
    updatedAt,
    createdAt
  } = filter;

  return (
    <Fragment>
      <div className="col-md-12">
        {/* Filtros empresa */}
        <h3 className="card-title mt-1">Filtros da empresa e colaborador</h3>
        <hr />
        <div className="row mb-2 p-20">
          <div className="col-md-2">
            <TextField
              name="socialName"
              label="Razão Social"
              value={socialName}
              onChange={onChange}
            />
          </div>
          <div className="col-md-2">
            <TextField
              name="cnpj"
              label="CNPJ"
              value={cnpj}
              onChange={onChange}
            />
          </div>
          <div className="col-md-2">
            <MaterialSelect
              name="SelectedCompanyStatus"
              dateLabel="Status empresa"
              value={SelectedCompanyStatus}
              data={dataDocuments.companyStatuses}
              onChange={onChange}
            />
          </div>
          <div className="col-md-2">
            <TextField
              name="EmployeeName"
              label="Nome colaborador"
              value={EmployeeName}
              onChange={onChange}
            />
          </div>
          <div className="col-md-2">
            <MaterialSelect
              name="SelectedEmployeeStatusId"
              dateLabel="Status colaborador"
              value={SelectedEmployeeStatusId}
              data={dataDocuments.employeeStatuses}
              onChange={onChange}
            />
          </div>
          <div className="col-md-6"></div>
        </div>
        <hr />
        {/* Filtros documentos */}
        <h3 className="card-title mt-4">Filtros dos documentos</h3>
        <hr />
        <div className="row mb-2 p-20">
          <div className="col-md-2 ">
            <DatePicker
              name="createdAt"
              data={dataDocuments.created}
              onChange={e => setCreatedAt(e)}
              dateLabel="Data de envio:"
            />
          </div>
          <div className="col-md-2">
            <DatePicker
              name="updatedAt"
              data={dataDocuments.updated}
              onChange={e => setUpdatedAt(e)}
              dateLabel="Última modificação:"
            />
          </div>
          <div className="col-md-2">
            <TextField
              name="SelectedDocName"
              label="Nome"
              value={SelectedDocName}
              onChange={onChange}
            />
          </div>
          <div className="col-md-6">
            <MaterialSelect
              name="SelectedDocuments"
              dateLabel="Documento"
              value={SelectedDocuments}
              data={dataDocuments.documentsList}
              onChange={onChange}

            />
          </div>
        </div>
        <div className="row mb-2 p-20">
          <div className="col-md-2">
            <MaterialSelect
              name="SelectedDocStatus"
              dateLabel="Status"
              value={SelectedDocStatus}
              data={dataDocuments.documentStatuses}
              onChange={onChange}
            />
          </div>
          <div className="col-md-2">
            <MaterialSelect
              name="SelectedDocSector"
              dateLabel="Área gestora"
              value={SelectedDocSector}
              data={dataDocuments.documentSectors}
              onChange={onChange}
            />
          </div>
          <div className="col-md-2 ">
            <FormControl className={classes.formControl}>
              <InputLabel htmlFor="month">Mês</InputLabel>
              <Select
                labelId="month"
                name="month"
                value={month}
                onChange={onChange}
              >
                <MenuItem></MenuItem>
                {CONSTANTS.months()
                  ? CONSTANTS.months().map(item => {
                      return (
                        <MenuItem key={item} value={item}>
                          {item}
                        </MenuItem>
                      );
                    })
                  : null}
              </Select>
            </FormControl>
          </div>
          <div className="col-md-2">
            <FormControl className={classes.formControl}>
              <InputLabel htmlFor="year">Ano</InputLabel>
              <Select
                labelId="year"
                name="year"
                value={year}
                onChange={onChange}
              >
                <MenuItem></MenuItem>
                {CONSTANTS.years()
                  ? CONSTANTS.years().map(item => {
                      return (
                        <MenuItem key={item} value={item}>
                          {item}
                        </MenuItem>
                      );
                    })
                  : null}
              </Select>
            </FormControl>
          </div>
          <div className="col-md-3 " className={classes.groupButtons}>
            <Button
              variant="contained"
              color="primary"
              size="small"
              className={"btn-info"}
              startIcon={<SearchIcon />}
              onClick={searchAttachs}
            >
              Pesquisar
            </Button>
            <Button
              size="small"
              className={"btn-info"}
              startIcon={<PictureAsPdfTwoToneIcon />}
              onClick={customPdfButton}
              className={classes.pdf}
            >
              PDF
            </Button>
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-md-12 mt-1">
            <MaterialTable
              title=""
              icons={tableIcons}
              isLoading={dataDocuments.load}
              options={{
                exportButton: true,
                exportAllData: true,
                defaultExpanded: true,
                exportCsv: (columns, renderData) => {
                  // Override default CSV export to use our Excel function
                  exportToExcel();
                }
              }}
              localization={{
                pagination: {
                  labelDisplayedRows: "{from}-{to} de {count}",
                  labelRowsSelect: "linhas",
                  previousTooltip: "Anterior",
                  nextTooltip: "Próxima",
                  lastTooltip: "Última"
                },
                body: {
                  emptyDataSourceMessage: "Não há dados a serem exibidos"
                },
                header: {
                  actions: "Ações"
                },
                grouping: {
                  groupedBy: "Agrupado por:",
                  placeholder: "Arraste os cabeçalhos aqui para agrupar"
                },
                toolbar: {
                  nRowsSelected: "{0} linha(s) selecionada(s)",
                  searchPlaceholder: "Pesquisar",
                  exportTitle: "Exportar para Excel",
                  exportName: "Exportar para Excel"
                }
              }}
              columns={dataDocuments.columns}
              data={dataDocuments.documentsAttached}
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default DocumentCompanyReport;
